export default __webpack_public_path__ + "static/media/my-account-profile-test.263b66ad.jpg";